import { requestHelpers } from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_PROFILE_INDUSTRIES: "SET_PROFILE_INDUSTRIES",
    GENERAL_INDUSTRIES_REQUEST: "GENERAL_INDUSTRIES_REQUEST",
    GENERAL_INDUSTRIES_SUCCESS: "GENERAL_INDUSTRIES_SUCCESS",
    GENERAL_INDUSTRIES_ERROR: "GENERAL_INDUSTRIES_ERROR",
}

export const setIndustries = ( profile ) => {
    const primary_industry = profile.industries.find( industry => industry.primary_industry === 1);
    return {
        type: actions.SET_PROFILE_INDUSTRIES,
        personId: profile.id,
        industries: profile.industries,
        primary_industry,
    }
}

export const industriesApiCall = ( personId, payload, type, callbackToHOC ) => {
    const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'POST' : type );
    const industryId = ( payload && payload.id ) || payload;

    return ( dispatch ) => {
        dispatch( {
            type: actions.GENERAL_INDUSTRIES_REQUEST,
            isLoading: true,
            isError: false,
        })

        requestHelpers
            .authenticatedPostRequest( `/profiles/${ personId }/industry/${ industryId }/primary`, null, requestType )
            .then( ( response ) => {
                callbackToHOC();
                return dispatch( {
                    type: actions.GENERAL_INDUSTRIES_SUCCESS,
                    personId: personId,
                    primary_industry: payload,
                })
            })
            .catch( ( error ) => {
                callbackToHOC( error );

            })
      dispatch(updateTodoList(personId, 8));

    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/industry.js